var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.15898 16.9753C-1.48625 8.71249 4.05659 3.2242 10.5947 3.2242H12.899M11.0372 0.75708L13.4505 3.00266C13.5775 3.12083 13.5789 3.32152 13.4535 3.4414L11.1563 5.63755M17.7993 7.53882C21.4445 15.8017 15.9017 21.29 9.36354 21.29H7.05929M8.92107 23.7571L6.50776 21.5115C6.38077 21.3933 6.37941 21.1926 6.50479 21.0728L8.80192 18.8766M12.095 9.50036H9.93772M9.93772 9.50036H9.26986C8.44727 9.50036 7.78043 10.1672 7.78043 10.9898C7.78043 11.8021 8.43128 12.4646 9.24346 12.479L10.7456 12.5056C11.4947 12.5189 12.095 13.13 12.095 13.8792C12.095 14.6379 11.48 15.253 10.7212 15.253H9.93772M9.93772 9.50036V7.90893M9.93772 15.253H7.78043M9.93772 15.253V16.6914",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.06e0d849619771677d8f76e1acb0464a.svg";
export { ForwardRef as ReactComponent };